var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRightShade = function SvgArrowRightShade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.977 6A.99.99 0 0 0 0 7c0 .552.437 1 .977 1h19.046c.54 0 .977-.448.977-1s-.437-1-.977-1z",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.472 12.293a1.017 1.017 0 0 0 0 1.414.96.96 0 0 0 1.382 0l5.86-6c.37-.378.383-.988.03-1.383l-5.373-6a.96.96 0 0 0-1.38-.061 1.017 1.017 0 0 0-.06 1.413l4.74 5.294z"
  })));
};
export default SvgArrowRightShade;